import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useMarket } from '../contexts/MarketContext';
import { MarketCode } from '../types/market';
interface MarketSelectorProps {
  tone?: 'light' | 'dark';
  className?: string;
  id?: string;
}

/**
 * Localization form — mirrors Shopify's native country/market selector
 * (`/localization` form). Changing it switches the active market, which
 * re-renders every price on the page from the same source of truth.
 */
export function MarketSelector({
  tone = 'dark',
  className = '',
  id = 'market-selector'
}: MarketSelectorProps) {
  const {
    market,
    markets,
    setMarketCode
  } = useMarket();
  const dark = tone === 'dark';
  return <div className={['flex items-center gap-2', className].join(' ')} data-id="element-156" data-mp="3arkrscclai74">
      <GlobeIcon className={['h-4 w-4 shrink-0', dark ? 'text-white/70' : 'text-muted'].join(' ')} aria-hidden="true" data-id="element-157" data-mp="3atxibdwey0vs" />
      <label htmlFor={id} className="sr-only" data-id="element-158" data-mp="2ib096gfxmorn">
        País y moneda
      </label>
      <select id={id} value={market.code} onChange={e => setMarketCode(e.target.value as MarketCode)} className={['cursor-pointer rounded-lg border bg-transparent py-1.5 pl-2 pr-7 text-xs font-semibold outline-none transition-colors', dark ? 'border-white/25 text-white hover:border-white/60 focus-visible:border-white' : 'border-navy/15 text-navy hover:border-navy/40 focus-visible:border-navy'].join(' ')} data-id="element-159" data-mp="yo93qn849sb8">
        {markets.map(m => <option key={m.code} value={m.code} className="text-ink" data-id="element-160" data-mp="axwqcwu3r3d9">
            {m.flag} {m.country} · {m.currency}
          </option>)}
      </select>
    </div>;
}